// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calendar-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21L21 21V10L3 10L3 21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 10V5L3 5L3 10L21 10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 10V5H3V10M21 10H3M21 10V21H3V10M7 5V2M17 5V2","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.4997 13.25L11.2571 17.4926L9.13574 15.3713","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Calendar2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-2',
    ref,
    icon: element,
  },
));

Calendar2Icon.displayName = 'Calendar2Icon';

export default Calendar2Icon;
